import { useField } from "formik";
import { Input } from "reactstrap";
import FormError from "./FormError";
import { ComponentProps } from "react";

type Props = {
  _errorProps?: ComponentProps<typeof FormError>;
  disabled?: boolean;
  name: string;
  placeholder: string;
  label?: string;
  required?: boolean;
  defaultValue?: string;
  className?: string;
};

export default function TextFormInput({ _errorProps, ...props }: Props) {
  const [field, meta] = useField(props);

  return (
    <div className={`flex flex-col ${props?.className}`}>
      {props.label && (
        <label className={`whitespace-nowrap	pb-1`}>
          {props.label} {props.required && "*"}
        </label>
      )}
      <Input disabled={props.disabled} {...field} placeholder={props.placeholder} status={meta.error && meta.touched ? "error" : ""} defaultValue={props.defaultValue} />
      <FormError {..._errorProps}>{meta.touched && meta.error}</FormError>
    </div>
  );
}
